import {useEffect, useState} from 'react';

export function resolveLocalePrefix(pathname) {
    const match = String(pathname || '').match(/^\/(en|uk)(?=\/|$)/);
    if (!match || match[1] === 'uk') {
        return '';
    }

    return `/${match[1]}`;
}

export function usePaymentPayload(apiUrl) {
    const [payload, setPayload] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let isCancelled = false;

        fetch(apiUrl, {credentials: 'same-origin'})
            .then(async (response) => {
                let data = {};
                try {
                    data = await response.json();
                } catch (error) {
                    data = {};
                }

                if (!response.ok) {
                    throw data;
                }

                return data;
            })
            .then((data) => {
                if (isCancelled) {
                    return;
                }

                if ((data?.state === 'redirect' || data?.state === 'unauthorized') && data?.redirectUrl) {
                    window.location.href = data.redirectUrl;
                    return;
                }

                setPayload(data);
            })
            .catch((errorPayload) => {
                if (isCancelled) {
                    return;
                }

                if (errorPayload?.redirectUrl) {
                    window.location.href = errorPayload.redirectUrl;
                    return;
                }

                setPayload({state: 'error'});
            })
            .finally(() => {
                if (!isCancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            isCancelled = true;
        };
    }, [apiUrl]);

    return {payload, isLoading};
}
